(function () {
    'use strict';

    angular.module("imApp").factory("prodSizeColliService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 911,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 912,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 1654,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
